import React from "react";
import { useQuery } from "@tanstack/react-query";
import i18nService from "../services/i18nService";

/**
 * A <select> over every language the platform supports (the Amazon Translate
 * set served by the backend). `value` is a language code or "" for "inherit".
 *
 * Props:
 *  - value, onChange(code | "")   controlled value
 *  - inheritLabel                 text for the empty option (omit to hide it)
 *  - className, disabled, id
 */
const LanguageSelect = ({
  value,
  onChange,
  inheritLabel,
  className = "",
  disabled = false,
  id,
}) => {
  const { data: languages = [], isLoading } = useQuery({
    queryKey: ["i18n", "languages"],
    queryFn: i18nService.getLanguages,
    staleTime: 24 * 60 * 60 * 1000, // the list only changes with a deploy
  });

  return (
    <select
      id={id}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled || isLoading}
      className={
        className ||
        "w-full px-3 py-2 border border-slate-300 rounded-full focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm bg-white disabled:bg-slate-50 disabled:text-slate-400"
      }
    >
      {inheritLabel !== undefined && <option value="">{inheritLabel}</option>}
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.name}
          {lang.native_name && lang.native_name !== lang.name
            ? ` · ${lang.native_name}`
            : ""}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelect;
